import { MoreVertical } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import type { Floorplan } from '@/types/api'
import type { CombinedColumnDef } from '@/api/dowload-excel.api'
import { formatDateTime } from '@/utils/format'

interface BuildColumnsOptions {
  pageIndex: number
  pageSize: number
  showUnitColumn: boolean
  canView: boolean
  canUpdate: boolean
  canDelete: boolean
  onViewDetail?: (floorplan: Floorplan) => void
  onUpdate?: (floorplan: Floorplan) => void
  onDelete?: (floorplan: Floorplan) => void
}

export function buildColumns({
  pageIndex,
  pageSize,
  showUnitColumn,
  canView,
  canUpdate,
  canDelete,
  onViewDetail,
  onUpdate,
  onDelete,
}: BuildColumnsOptions): CombinedColumnDef<Floorplan>[] {
  return [
    {
      id: 'stt',
      header: 'STT',
      size: 55,
      align: 'center',
      cell: ({ row }) => row.index + 1 + pageIndex * pageSize,
    },
    {
      accessorKey: 'name',
      header: 'TÊN SƠ ĐỒ',
      align: 'left',
      cell: ({ row }) => (
        <button
          type="button"
          className="cursor-pointer text-[#CE7A58] hover:text-[#b8694a]"
          onClick={() => onViewDetail?.(row.original)}
        >
          {row.original.name}
        </button>
      ),
    },
    ...(showUnitColumn
      ? [
          {
            accessorKey: 'unitName',
            header: 'ĐƠN VỊ',
            align: 'left',
            cell: ({ getValue }) => (getValue() as string) || '-',
          } satisfies CombinedColumnDef<Floorplan>,
        ]
      : []),
    {
      accessorKey: 'updatedAt',
      header: 'NGÀY CẬP NHẬT',
      size: 130,
      align: 'center',
      cell: ({ getValue }) => formatDateTime(getValue()),
    },
    {
      id: 'actions',
      size: 60,
      align: 'center',
      exportable: false,
      cell: ({ row }) => (
        <div className="flex justify-center">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" className="h-8 w-8">
                <MoreVertical />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-40">
              {canView && (
                <DropdownMenuItem
                  className="cursor-pointer"
                  onClick={() => onViewDetail?.(row.original)}
                >
                  Xem chi tiết
                </DropdownMenuItem>
              )}
              {canUpdate && (
                <DropdownMenuItem
                  className="cursor-pointer"
                  onClick={() => onUpdate?.(row.original)}
                >
                  Cập nhật
                </DropdownMenuItem>
              )}
              {canDelete && (
                <DropdownMenuItem
                  className="cursor-pointer text-red-600"
                  onClick={() => onDelete?.(row.original)}
                >
                  Xóa
                </DropdownMenuItem>
              )}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      ),
    },
  ]
}
